// src/features/clinical/components/common/Timeline.jsx
import React from 'react';
import { FaCalendar, FaUserMd, FaPrescription, FaFlask } from 'react-icons/fa';
import { formatDate } from '../../utils/clinicalHelpers';

const Timeline = ({ events }) => {
  const getIcon = (type) => {
    switch(type) {
      case 'visit':
        return <FaUserMd className="text-blue-600" />;
      case 'prescription':
        return <FaPrescription className="text-green-600" />;
      case 'test':
        return <FaFlask className="text-purple-600" />;
      default:
        return <FaCalendar className="text-gray-600" />;
    }
  };

  const getBgColor = (type) => {
    switch(type) {
      case 'visit':
        return 'bg-blue-100';
      case 'prescription':
        return 'bg-green-100';
      case 'test':
        return 'bg-purple-100';
      default:
        return 'bg-gray-100';
    }
  };

  return (
    <div className="flow-root">
      <ul className="-mb-8">
        {events.map((event, index) => (
          <li key={event.id}>
            <div className="relative pb-8">
              {index < events.length - 1 && (
                <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" />
              )}
              <div className="relative flex space-x-3">
                <div>
                  <span className={`h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white ${getBgColor(event.type)}`}>
                    {getIcon(event.type)}
                  </span>
                </div>
                <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                  <div>
                    <p className="text-sm text-gray-500">{event.description}</p>
                    {event.details && (
                      <p className="mt-1 text-sm text-gray-700">{event.details}</p>
                    )}
                  </div>
                  <div className="text-right text-sm whitespace-nowrap text-gray-500">
                    <time dateTime={event.date}>{formatDate(event.date)}</time>
                  </div>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Timeline;